import CommunitySplitPillTag from './CommunitySplitPillTag'

export default CommunitySplitPillTag
export * from './CommunitySplitPillTag'
